var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 50.625C38.9227 50.625 49.5 40.0477 49.5 27C49.5 13.9523 38.9227 3.375 25.875 3.375C12.8273 3.375 2.25 13.9523 2.25 27C2.25 40.0477 12.8273 50.625 25.875 50.625Z",
    fill: "url(#paint0_linear_11981_24468)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 5.625L27 25.875L16.875 18L13.5 21.375L27 34.875L52.875 7.875L49.5 5.625Z",
    fill: "#3DA64F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11981_24468",
    x1: 25.875,
    y1: 3.375,
    x2: 25.875,
    y2: 50.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8F3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EE0B1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessImage);
export default __webpack_public_path__ + "static/media/success_image.0b77693b3433326924045ca94b7f2a18.svg";
export { ForwardRef as ReactComponent };